const constants = {
    TRAVCHK: 'TRAVCHK',
    CHECKOUT_TYPES: {
        OLP_CHECKOUT: 'OLP',
        OLB_CHECKOUT: 'OLB',
        REMIT_PAYMENT_CHECKOUT: 'REMIT_PAYMENT',
        VAS_CART_CHECKOUT: 'VASCART',
    },
    // Passed into prepare/commence to differntiate checkout type
    CHECKOUT_ORIGINS: {
        BOOKING: 'BOOKING',
        PAYMENT: 'PAYMENT',
        // The below are the only accepted AOE values
        VAS_CART: 'VAS_CART',
        VAS_INTERSTITIAL: 'VAS_INTERSTITIAL',
        UNDEFINED: 'UNDEFINED',
    },
    PAYMENT: 'PAYMENT',
    PRIOR_AUTH: 'PRIOR_AUTH',
    ADYEN_URL: 'https://live.adyen.com/hpp/js/df.js?v=',
    PAYMENTS_CHECK_STAGE_URL: 'https://payments-stage.homeaway.com/check',
    PAYMENTS_CHECK_PROD_URL: 'https://payments.homeaway.com/check',
    MIN_SUPERLATIVE_RATING: 3.7,
    EXPIRED: 'EXPIRED',
    STATE: 'State',

    // These values should mirror http://github.wvrgroup.internal/core-api/api-domain/blob/master/src/main/java/com/homeaway/api/domain/enums/CreatedByApp.java
    // See https://wiki.homeawaycorp.com/pages/viewpage.action?spaceKey=~MKlobe&title=Adding+App+Attributes+to+Messages
    CREATED_BY_APP_VALUES: {
        MOBILE_TRAVELER_ANDROID: 'MOBILE_TRAVELER_ANDROID',
        MOBILE_TRAVELER_IOS: 'MOBILE_TRAVELER_IOS',
        VRBO: 'VRBO',
        GT: 'GT',
    },

    analytics: {
        CHECKOUT_PAGE_OLP_PAGE_NAME: 'payment: traveler checkout page',
        CHECKOUT_PAGE_OLP_PAGE_TYPE: 'booking payment',
        CHECKOUT_PAGE_OLP_PAGE_URL: '/vpv/traveler/bookingpayment/checkout',

        CHECKOUT_PAGE_OLB_PAGE_NAME: 'haolb : traveler checkout page',
        CHECKOUT_PAGE_OLB_PAGE_TYPE: 'booking',
        CHECKOUT_PAGE_OLB_PAGE_URL: '/vpv/traveler/booking/checkout',

        RULES_PAGE_OLP_PAGE_NAME: 'payment: traveler rules policies page',
        RULES_PAGE_OLP_PAGE_URL: '/vpv/traveler/bookingpayment/rulespolicies',

        RULES_PAGE_OLB_PAGE_NAME: 'haolb : traveler rules policies page',
        RULES_PAGE_OLB_PAGE_URL: '/vpv/traveler/booking/rulespolicies',

        TRIP_PROTECTION_OLP_PAGE_NAME: 'payment: traveler trip protection page',
        TRIP_PROTECTION_OLP_PAGE_URL:
            '/vpv/traveler/bookingpayment/tripprotection',

        TRIP_PROTECTION_OLB_PAGE_NAME: 'haolb : traveler trip protection page',
        TRIP_PROTECTION_OLB_PAGE_URL: '/vpv/traveler/booking/tripprotection',

        PAYMENT_PAGE_OLP_PAGE_NAME: 'payment: traveler payment page',
        PAYMENT_PAGE_OLP_PAGE_URL: '/vpv/traveler/bookingpayment/payment',

        PAYMENT_PAGE_OLB_PAGE_NAME: 'haolb : traveler payment page',
        PAYMENT_PAGE_OLB_PAGE_URL: '/vpv/traveler/booking/payment',

        PAYMENT_PAGE_REMIT_PAGE_NAME: 'payment: offline traveler checkout page',
        PAYMENT_PAGE_REMIT_PAGE_TYPE: 'booking payment',

        VAS_INTERSTITIAL_OLP_PAGE_NAME: 'payment: traveler vas page',
        VAS_INTERSTITIAL_OLP_PAGE_URL: '/vpv/traveler/bookingpayment/vas',

        VAS_INTERSTITIAL_OLB_PAGE_NAME: 'haolb : traveler vas page',
        VAS_INTERSTITIAL_OLB_PAGE_URL: '/vpv/traveler/booking/vas',

        CONFIRMATION_PAGE_OLP_PAGE_NAME:
            'payment: traveler payments confirmation page',
        CONFIRMATION_PAGE_OLP_PAGE_TYPE: 'booking payment',
        CONFIRMATION_PAGE_OLP_PAGE_URL:
            '/vpv/traveler/bookingpayment/confirmation',

        CONFIRMATION_PAGE_OLB_PAGE_NAME: 'haolb : traveler confirmation page',
        CONFIRMATION_PAGE_OLB_PAGE_TYPE: 'booking',
        CONFIRMATION_PAGE_OLB_PAGE_URL: '/vpv/traveler/booking/confirmation',

        CONFIRMATION_PAGE_REMIT_PAGE_NAME:
            'payment: offline traveler payments confirmation page',
        CONFIRMATION_PAGE_REMIT_PAGE_TYPE: 'booking payment',
        CONFIRMATION_PAGE_REMIT_PAGE_URL:
            '/vpv/traveler/bookingpayment/offlineconfirmation',

        VAS_CART_CHECKOUT_PAGE_NAME: 'vas: traveler checkout page',
        VAS_CART_CHECKOUT_PAGE_TYPE: 'booking vas',
        VAS_CART_CHECKOUT_PAGE_URL: '/vpv/traveler/bookingvas/checkout',

        VAS_CART_CONFIRMATION_PAGE_NAME: 'vas: traveler confirmation page',
        VAS_CART_CONFIRMATION_PAGE_TYPE: 'booking vas',
        VAS_CART_CONFIRMATION_PAGE_URL: '/vpv/traveler/bookingvas/confirmation',

        UNKNOWN_CONFIRMATION_PAGE_NAME: 'haolb : unknown page',
        UNKNOWN_CONFIRMATION_PAGE_TYPE: 'unknown',

        GUEST_CHOICE_BADGE_PRESENTED: 'GUEST_CHOICE.PRESENTED',
    },

    paymentAttributeTypes: {
        ADDRESS: 'ADDRESS',
        EMAIL: 'EMAIL',
        URL: 'URL',
        PHONE: 'PHONE',
        TEXT: 'TEXT',
        LASTSIX: 'LASTSIX',
    },

    paymentStatus: {
        OVERDUE: 'OVERDUE',
        PENDING: 'PENDING',
        NOT_STARTED: 'NOT_STARTED',
        PENDING_ACCEPTANCE: 'PENDING_ACCEPTANCE',
        PAID: 'PAID',
        SENT: 'SENT',
        PARTIAL_REFUNDED: 'PARTIAL_REFUNDED',
        REFUNDED: 'REFUNDED',
        REVERSED: 'REVERSED',
        SCHEDULED: 'SCHEDULED',
    },

    payDamageClaimStatus: {
        CAPTURE_READY: 'CAPTURE_READY',
        CAPTURED: 'CAPTURED',
        SUCCESS: 'SUCCESS',
        PAYNOW: 'PAYNOW',
        DUPLICATE: 'DUPLICATE',
    },

    paymentTypes: {
        PLATFORM: 'platform',
        OFF_PLATFORM: 'OFF_PLATFORM', // for IPM Invoice in checkout service
        OFFLINE: 'offline', // Offline Payments, e.g., PayPal, Check, Bank Transfer (non IPM)
    },

    paymentFormTypes: {
        CARD: 'CARD',
        ECHECK: 'ECHECK',
        INVOICE: 'INVOICE',
        DEFERRED: 'DEFERRED',
        OTHER_PAY_OPTIONS: 'OTHER-PAY-OPTIONS',
        MOBILE: 'MOBILE',
        SAVED_CREDIT_CARD: 'SAVED_CREDIT_CARD',
        CREDIT_CARD: 'CREDIT_CARD',
        PAYPAL_ONLINE: 'PAYPAL_ONLINE',
        AFFIRM: 'AFFIRM',
        OFF_PLATFORM: 'OFF_PLATFORM',
    },

    paymentCollectionTypes: {
        TRAVELER_SITE: 'TRAVELER_SITE',
    },

    // CHK-8592 - remove apple pay and related a/b tests.
    // leaving all constants related to apple pay in this file,
    // as they are based on server data, and not the legacy
    // client side implementation of apple pay
    mobilePaymentTypes: {
        APPLE_PAY: 'APPLE_PAY',
    },

    paymentFormConfig: {
        BILLING_FULL_NAME_MAX_LENGTH: 50,
        CONTACT_DETAILS_FULL_NAME_MAX_LENGTH: 100,
    },

    FLEX_PAY: {
        SINGLE_PAYMENT: '1',
        MULTIPLE_PAYMENTS: '0',
    },

    CHECK_IN: 'CHECK_IN',

    CHECK_OUT: 'CHECK_OUT',

    LOG: {
        SERVER_ERROR: 'server error occurred ',
        TIMEOUT_ERROR: 'timeout occurred',
        UNSUPPORTED_BROWSER_ERROR: 'unsupported browser error occurred',
        UNSUPPORTED_DATES_ERROR: 'unsupported dates error occurred',
        UNSUPPORTED_GUESTS_AMOUNT_ERROR:
            'unsupported guests amount error occurred',
        UNSUPPORTED_PETS_VALUE_ERROR: 'unsupported pets value error occurred',
        NO_ERROR_PROVIDED: 'server error occurred with no error message',
        BOOKING_IN_PROGRESS: 'booking in progress',
        HAPI_POST_ERROR: 'error posting to hapi iframes',
    },
    INSURTECH: {
        EXPERIMENTS: {
            US_CONVERGENCE_EXPERIMENT:
                'Insurtech_Vrbo_Convergence_Milestone_One_Switch_VAS_Cart_Page',
            CA_CONVERGENCE_EXPERIMENT: 'Vrbo_Convergence_Canada_Traffic_Split',
        },
        LOGS: {
            SUCCESSFULLY_RENDERED:
                'insurtech.component: operation=load productName={product_type} status=success',
            EMPTY_RESPONSE:
                'insurtech.component: operation=load productName={product_type} status=empty_response',
            FAILED_RENDERED:
                'insurtech.component: operation=load productName={product_type} status=failed',
            ADD_SUCCESS:
                'insurtech.component: operation=add productName={product_type} status=success',
            ADD_FAILED:
                'insurtech.component: operation=add productName={product_type} status=failed',
            REMOVE_FAILED:
                'insurtech.component: operation=remove productName={product_type} status=failed',
            REMOVE_SUCCESS:
                'insurtech.component: operation=remove productName={product_type} status=success',
            PRICE_CHANGE_FAILED:
                'insurtech.component: operation=price_change productName={product_type} status=failed',
            PRICE_CHANGE_SUCCESS:
                'insurtech.component: operation=price_change productName={product_type} status=success',
            PRICE_CHANGE_REMOVE_FAILED:
                'insurtech.component: operation=price_change_remove_selection productName={product_type} status=failed',
            PRICE_CHANGE_ADD_FAILED:
                'insurtech.component: operation=price_change_add productName={product_type} status=failed',
            PRICE_CHANGE_RE_FETCH_FAILED:
                'insurtech.component: operation=price_change_re_fetch productName={product_type} status=failed',
            RESET_SELECTION_SUCCESS:
                'insurtech.component: operation=price_change_reset_selection productName={product_type} status=success',
            RESET_SELECTION_FAILED:
                'insurtech.component: operation=price_change_reset_selection productName={product_type} status=failed',
            SUBMIT_BUTTON:
                'insurtech.component: operation=submit productName={product_type} status=clicked',
            HYBRID_CONTEXT_MISSING:
                'insurtech.component: operation=load operationName=hybrid_client_context status=failed',
            BEGIN_RENDERING: 'insurtech.component: operation=load status=start',
            IN_PROGRESS_RENDERING:
                'insurtech.component: operation=load status=in_progress',
        },
        OPERATION_NAME: {
            INSURTECH_SHOPPING: 'shopInsurtechLegacyCheckout',
            INSURTECH_CONVERGENCE_SHOPPING: 'insurtechConvergenceShopping',
            CREATE_VAS_CHECKOUT: 'createVasCheckout',
            HYBRID_CLIENT_CONTEXT: 'getHybridClientContext',
            UNAVAILABLE: 'Unavailable',
        },
        REASONS: {
            FETCH_ERROR: 'fetch_error',
            VAS_NOT_ALLOWED_FOR_RESERVATION: 'vas_not_allowed_for_reservation',
            SHOW_VAS_CART_FALSE: 'show_vas_cart_false',
            MODEL_ERRORS_PRESENT: 'model_errors_present',
            NO_ELIGIBLE_COUNTRIES: 'no_eligible_countries',
            TRIP_COVERAGE_EXCEPTION: 'trip_coverage_exception',
        },
    },
    offlinePaymentModes: {
        ONLINE: 'ONLINE',
        OFFLINE: 'OFFLINE',
        ONLINE_OR_OFFLINE: 'ONLINE_OR_OFFLINE',
    },

    OFFLINE_PAYMENT_TYPES: {
        PAYPAL: 'PAYPAL',
    },

    PAYMENT_METHOD_ATTRIBUTES: {
        INVOICE: 'INVOICE',
    },

    POLICY_TYPES: {
        DAMAGE_LIABILITY: 'DAMAGE_LIABILITY',
    },

    travelerFee: {
        TRAVELER_FEE: 'TRAVELER_FEE',
        VAT: 'VAT',
        GST: 'GST',
    },
    PAGE: {
        MODAL_OPEN_HASH: '#modal-open',
        RESERVATION_MODAL_OPEN: '#modal-reservation-open',
        SIDEBAR_MODAL_OPEN_HASH: '#sidebar-modal-open',
        CAROUSEL_MODAL_OPEN_HASH: '#modal-carousel-open',
        HOUSERULES_MODAL_OPEN_HASH: '#modal-rules-open',
        THREEDS_MODAL_OPEN_HASH: '#modal-threeds-open',
        QUOTE_DETAILS_OPEN: '#quote-open',
        MANAGER_NOTES_MODAL_OPEN: '#manager-notes-modal-open',
        STEPPED_CHECKOUT: {
            CONTACT_DETAILS: '#contact-details',
            RULES_POLICIES: '#rules-policies',
            TRIP_PROTECTION: '#trip-protection',
            PAYMENT: '#payment',
            HISTORY: 'stepped-checkout-history',
            HISTORY_LENGTH: 'stepped-checkout-history-length',
            EVENTS: {
                '#contact-details': 'traveler-checkout:render-contact-details',
                '#rules-policies': 'traveler-checkout:render-rules',
                '#trip-protection': 'traveler-checkout:render-trip-protection',
                '#payment': 'traveler-checkout:render-payment',
            },
            HASH: {
                'traveler-checkout:render-contact-details': '#contact-details',
                'traveler-checkout:render-rules': '#rules-policies',
                'traveler-checkout:render-trip-protection': '#trip-protection',
                'traveler-checkout:render-payment': '#payment',
            },
            HASH_NAMESPACE: {
                '#contact-details': 'Contact',
                '#rules-policies': 'Rules',
                '#trip-protection': 'Trip Protection',
                '#payment': 'Payment',
            },
        },
        AFFIRM_LEARNMORE_OPEN: '#affirm-learnmore-open',
    },

    EVENTS: {
        STEP_ONE_CTA_PROCESS: 'traveler-checkout:process-step-one-cta',
        RENTAL_DETAILS_CTA_PROCESS:
            'traveler-checkout:process-rental-details-cta',
        ADD_VAS_PRODUCT: 'vas-widgets:add-product',
        ADD_VAS_INTERSTITIAL_PRODUCT: 'vas-interstitial:add-product',
        CLICK_ADD_VAS_PRODUCT: 'vas-widgets:click-add-product',
        REMOVE_VAS_PRODUCT: 'vas-widgets:remove-product',
        REMOVE_VAS_INTERSTITIAL_PRODUCT: 'vas-interstitial:remove-product',
        UPDATE_TOTALS: 'sidebar:update-totals',
        UPDATE_TOTALS_COMPLETE: 'sidebar:update-totals-complete',
        RENDER_SIDEBAR: 'traveler-checkout:sidebar-render',
        SYNC_VAT_NUMBER: 'traveler-checkout:sync-vat-number',
        SYNC_VAT_VALIDATION: 'traveler-checkout:sync-vat-validation',
        RENDER_CONTACT_DETAILS: 'traveler-checkout:render-contact-details',
        RENDER_RULES: 'traveler-checkout:render-rules',
        RENDER_RULES_COMPLETE: 'traveler-checkout:render-rules-complete',
        HIDE_PANELS: 'traveler-checkout:hide-panels',
        CHALLENGE_MODAL_CANCEL: 'traveler-checkout:cancel-challenge-modal',
        COUNTRY_CODE_CHANGE: 'traveler-checkout:country-code-change',
        APPLY_VAT_ID: 'traveler-checkout:apply-vat-id',
        SUBMIT_OFFLINE_PAYMENT: 'traveler-checkout:submit-offline-payment',
        SUBMIT_ORDER: 'traveler-checkout:submit-order',
        SUBMIT_FINISHED: 'traveler-checkout:submit-finished',
        REFRESH_HAPI: 'traveler-checkout:refresh-hapi',
        TRANSACTION_ERRORS: 'traveler-checkout:transaction-errors',
        PAYMENT_ERROR: 'traveler-checkout:payment-errors',
        REMOVE_PAYMENT_ERROR: 'traveler-checkout:remove-payment-errors',
        CONTACT_DETAILS_NAME: 'traveler-checkout:contact-details-name',
        CONTACT_DETAILS_CHANGE_NAME:
            'traveler-checkout:contact-details-check-names',
        HAPI_FIELD_CHANGED: 'hapi:field-focus-or-text-change',
        RESET_ELIGIBLE_VAS_PRODUCTS:
            'traveler-checkout:reset-eligible-vas-products',
        RESET_CES_PAYLOAD: 'traveler-checkout:reset-ces-payload',
        DISPLAY_VAT_ID: 'traveler-checkout:display-vat-id',
        CLEAR_URGENCY_TIMER: 'traveler-checkout:clear-urgency',
        RENDER_TRIP_PROTECTION: 'traveler-checkout:render-trip-protection',
        UPDATE_INSTALLMENTS: 'traveler-checkout:update-payment-installments',
        RENDER_PAYMENT: 'traveler-checkout:render-payment',
        VALIDATE_VAS_CART: 'traveler-checkout:validate-vas-cart',
        CLOSE_IMAGE_CAROUSEL: 'image carousel closed',
        HIDE_PAYMENT: 'traveler-checkout:hide-payment-panels',
        LOGIN_ON_CHECKOUT: 'traveler-checkout:login-on-checkout',
        UPDATE_ECHECK_AMOUNT: 'traveler-payments-module:update-echeck-amount',
        FORWARD_PAYPAL_CHECKOUT: 'traveler-checkout:forward-paypal-checkout',
        CS_UPDATE_COMPLETE: 'vrbo-checkout-service:update-complete',
        TRIGGER_OPT_IN_MARKETING_API:
            'traveler-checkout:trigger-opt-in-marketing-api',
        IS_VAT_VALIDATING: 'traveler-checkout:vat-validating',
    },

    NATIVE_EVENTS: {
        INVALID_CHECKOUT: 'Invalid Checkout',
    },

    /**
     * Keys that are a specific language that do not require translation.
     * This is to prevent keys from being duplicated in Lingua when we create new bundles for translations.
     */
    LINGUA: {
        KEYS: {
            VAT_REGION: 'vat.region.',
        },
    },

    CARD_TYPES: {
        AMEX: 'amex',
    },

    PAYMENT_METHOD_TYPES: {
        AFFIRM: 'AFFIRM',
        APPLE_PAY: 'APPLE_PAY',
        CREDIT_CARD: 'CREDIT_CARD',
        ECHECK: 'ECHECK',
        OFF_PLATFORM: 'OFF_PLATFORM',
        PAYPAL_ONLINE: 'PAYPAL_ONLINE',
        SAVED_CREDIT_CARD: 'SAVED_CREDIT_CARD',
    },

    PAYMENT_METHOD_ICONS: {
        AMEX: 'icon-cc-amex',
        BANK: 'icon-cc-bank',
        BLANK: 'icon-cc-blank',
        CARTA_SI: 'icon-cc-carta-si',
        CARTE_BLANCHE: 'icon-cc-carte-blance',
        CARTE_BLEU: 'icon-cc-cartebleue',
        DANKORT: 'icon-cc-dankort',
        DELTA: 'icon-cc-delta',
        DINERS: 'icon-cc-diners',
        DISCOVER: 'icon-cc-discover',
        ECHECK: 'icon-cc-echeck',
        ENROUTE: 'icon-cc-enroute',
        JAL: 'icon-cc-jal',
        JCB: 'icon-cc-jcb',
        LASER: 'icon-cc-laser',
        MAESTRO_INTERNATIONAL: 'icon-cc-maestro',
        MAESTRO_UK: 'icon-cc-maestro',
        MASTERCARD: 'icon-cc-mastercard',
        PAYPAL_ONLINE: 'icon-cc-paypal',
        SOLO: 'icon-cc-solo',
        VISA: 'icon-cc-visa',
        VISA_ELECTRON: 'icon-cc-visa-electron',
    },

    ID_TYPES: {
        TAX_ID: 'TAX_ID',
        PASSPORT: 'PASSPORT',
    },

    EXPIRATION_FIELDS: {
        MONTH: 'cc-exp-month',
        YEAR: 'cc-exp-year',
    },

    BOOTSTRAP: {
        EXTRA_SMALL_VIEWPORT: 'visible-xs-block',
        SMALL_VIEWPORT: 'visible-sm-block',
        MEDIUM_VIEWPORT: 'visible-md-block',
        LARGE_VIEWPORT: 'visible-lg-block',
    },

    ERROR_CODES: {
        ECP012: 'ECP012',
        TCB030: 'TCB030',
        PE0900: 'PE0900',
        // Invalid # of guests
        ECP009: 'ECP009',
        // Children not allowed
        TCB053: 'TCB053',
    },

    ERROR_KEYS: {
        CARD_DECLINED: 'traveler.checkout.transaction.invalid.card_declined',
        BAP010: 'BAP010',
    },

    BRAND_IDS: {
        HOMEAWAY_BR: '126',
        HOMEAWAY_DE: '651',
        VRBO: '321',
        HOMEAWAY_UK: '611',
    },

    EU_BRANDS: [
        '611', // HOMEAWAY_UK
        '614', // HOMEAWAY_IT
        '615', // HOMEAWAY_ES
        '616', // HOMEAWAY_PT
        '617', // HOMEAWAY_NL
        '618', // HOMEAWAY_SE
        '619', // HOMEAWAY_NO
        '621', // HOMEAWAY_DK
        '622', // HOMEAWAY_FI
        '629', // HOMEAWAY_PL
        '635', // HOMEAWAY_GR
        '651', // HOMEAWAY_DE
        '656', // HOMEAWAY_AT
        '731', // ABRITEL
    ],

    SITES: {
        ABRITEL: 'abritel',
        HOMEAWAY_BR: 'homeaway_br',
        HOMEAWAY_DE: 'homeaway_de',
        HOMEAWAY_ES: 'homeaway_es',
        HOMEAWAY_IT: 'homeaway_it',
        HOMEAWAY_UK: 'homeaway_uk',
        HOMEAWAY_US: 'homeaway_us',
        STAYZ: 'stayz',
        VRBO: 'vrbo',
    },

    DISTRIBUTION_CHANNELS: {
        EXPEDIA: 'expedia',
    },

    VAS: {
        DAMAGE_PROTECTION: 'DAMAGE_PROTECTION',
        PROPERTY_DAMAGE_PROTECTION: 'PROPERTY_DAMAGE_PROTECTION',
        MULTITIER_TINT: 'MULTITIER_TINT',
        TINT_PRIME: 'TINT_PRIME',
        TINT_BASIC: 'TINT_BASIC',
        TINT_ENHANCED: 'TINT_ENHANCED',
        TINT_PREMIUM: 'TINT_PREMIUM',
        RDD: 'RDD',
        CSA_ADP: 'CSA_ADP',
        WEATHER_PROMISE: 'WEATHER_PROMISE',
        CSA_TCP: 'CSA_TCP',
        CSA_PDP: 'CSA_PDP',
        PDP: 'PDP',
        EA_ADP_UK: 'EA_ADP_UK',
        EA_ADP_AB: 'EA_ADP_AB',
        EA_ADP_FD: `EA_ADP_FD`,
        EA_ADP_NL: `EA_ADP_NL`,
        EA_ADP_IT: 'EA_ADP_IT',
        EA_ADP_CA: 'EA_ADP_CA',
        EA_TI_AB: 'EA_TI_AB',
        EA_TI_IT: 'EA_TI_IT',
        EA_TI_UK: 'EA_TI_UK',
        EA_TI_FD: 'EA_TI_FD',
        EA_TI_CA: 'EA_TI_CA',
        TI_CA_NMD_QC: 'TI_CA_NMD_QC',
        COF: 'COF',
        NO_SELECTION: 'NO_SELECTION',
    },

    GATEWAY: {
        ADYEN: 'ADYEN',
        YAPSTONE: 'YAPSTONE',
        YAPSTONE_EU: 'YAPSTONE_EU',
    },

    PROPERTY_TYPE: {
        INTEGRATED_PM: 'INTEGRATED_PM',
        OWNER: 'OWNER',
        PLATFORM_PM: 'PLATFORM_PM',
    },

    DAMAGE_DEPOSIT_TYPE: {
        AUTO: 'AUTO',
        MANUAL: 'MANUAL',
    },

    ZERO_VALUE_UUID: '00000000-0000-0000-0000-000000000000',

    PANELS: {
        CONTACT_DETAILS: 'CONTACT_DETAILS',
        RULES: 'RULES',
        TRIP_PROTECTION: 'TRIP_PROTECTION',
        TRIP_PROTECTION_RULES_CHECK: 'TRIP_PROTECTION_RULES_CHECK',
        PAYMENT: 'PAYMENT',
        VAS: 'VAS',
        PDC: 'PDC',
    },

    CONTROLLERS: {
        CHECKOUT: 'checkout',
        PAYMENT: 'payment',
    },

    TIMERS: {
        APPLE_PAY_ELIGIBLE: 5000,
        URGENCY_MODAL_TIMER: 30000,
    },

    STORAGE: {
        COMPLETED_TRIP_CANCELLATION: 'completedTripCancellation',
        STEP_ONE_COMPLETE: 'stepOneComplete',

        IS_NATIVE_MOBILE_ANDROID_REQUEST_CACHED:
            'isNativeMobileAndroidRequestCached',
        IS_NATIVE_MOBILE_IOS_REQUEST_CACHED: 'isNativeMobileIOSRequestCached',
        LISTING_INFO: 'listingInfo',

        QUOTE_DETAILS: 'quoteDetails',
        USER_VAS_DETAILS: 'userVasDetails',
        USER_CONTACT_DETAILS: 'userContactDetails',
        USER_CONTACT_DETAILS_OLP: 'userContactDetailsOlp',
        PAYMENT_DETAILS: 'paymentDetails',

        CONTACT_DETAILS_MODEL: 'contactDetailsModel',
        CHECKOUT_MODEL: 'checkoutModel',
        CONFIRMATION_DATA: 'confirmationData',

        PAYMENT_INSTRUMENT_UUID: 'paymentInstrumentUUID',

        PROPERTY_DETAILS_ANALYTICS: 'propertyDetailsAnalytics',
        VAS_INSTERTITIAL_TIMER: 'vasInterstitialTimer',
    },

    CANCELLATION_POLICY_SOURCES: {
        UNIT_RENTAL_POLICY: 'UNIT_RENTAL_POLICY',
        RATE_PLAN: 'RATE_PLAN',
    },

    // quote cancellation policies
    CANCELLATION_POLICY_TYPES: {
        STRICT: 'Strict',
        FIRM: 'Firm',
        MODERATE: 'Moderate',
        RELAXED: 'Relaxed',
        NON_REFUNDABLE: 'NoRefund',
        FLEXIBLE: 'Flexible',
    },

    // lodging cancel policy types as defined here
    // https://github.expedia.biz/vrbo-graphql/graphql-vrbo/blob/master/packages/graphql-lodging-policy/lib/resolvers/util/handleCancellationPolicyData.js#L6
    LODGING_CANCELLATION_POLICY_TYPES: {
        STRICT: 'STRICT',
        FIRM: 'FIRM',
        MODERATE: 'MODERATE',
        RELAXED: 'RELAXED',
        FLEXIBLE: 'FLEXIBLE',
        NO_REFUND: 'NO_REFUND',
        NOT_CONFIGURED: 'NOT_CONFIGURED',
    },

    EDAP_CANCELLATION_POLICY_TYPES: {
        STRICT: 'Strict',
        FIRM: 'Firm',
        MODERATE: 'Moderate',
        RELAXED: 'Relaxed',
        FLEXIBLE: 'Custom(IPM)',
        NO_REFUND: 'No_Refund',
        OTHER: 'Other',
    },

    EDAP_CATEGORIES: {
        TRAVELER_WALLET: 'traveler wallet',
        APPLE_PAY: 'apple pay',
        TRAVELER_CHECKOUT: 'traveler checkout',
        THREE_DS: '3DS',
        HOUSE_RULES: 'House Rules',
        FLEX_PAY: 'flexpay',
        CHECKOUT: 'checkout',
        PDP: 'pdp',
        PRICE_DETAILS: 'price_details',
        VAS_INTERSTITIAL: 'vas-interstitial',
    },

    EDAP_EVENTS: {
        BOOKING_FAILURE_PRESENTED: 'booking_failure.presented',
        BOOKING_REQUEST_SUBMITTED: 'booking_request.submitted',
        BOOKING_REQUEST_SUCCEEDED: 'booking_request.succeeded',
        CHECKOUT_PRESENTED: 'checkout.presented',
        BOOKING_VALIDATION_ERROR_PRESENTED:
            'booking_validation_error.presented',
        MAX_GUESTS_ERROR: 'max.guest.error',
        PAYMENT_VALIDATION_ERROR: 'payment.validation.error',
        MARKETING_OPT_IN_PRESENTED: 'marketing_opt_in.presented',
        MARKETING_OPT_IN_SELECTED: 'marketing_opt_in.selected',
        MARKETING_OPT_IN_SUBMITTED: 'marketing_opt_in.submitted',
        INSURTECH_HWCP_PRESENTED: 'insurtech_hwcp.presented',
        INSURTECH_HWC_UPDATE_FAILED: 'insurtech_hwc.update.failed',
        INSURTECH_HWC_UPDATE_SUCCESS: 'insurtech_hwc.update.success',
        INSURTECH_HWC_PRICE_CHANGE_SUCCESS:
            'insurtech_hwc.price_change.success',
        INSURTECH_HWC_PRICE_CHANGE_FAILED: 'insurtech_hwc.price_change.failed',
        INSURTECH_HWC_REMOVE_OFFER_FAILED: 'insurtech_hwc.remove_offer.failed',
        INSURTECH_MODULE_NO_DATA: 'insurtech_module.no_data',
        INSURTECH_MODULE_QUERY_ERROR: 'insurtech_module.query.error',
        INSURTECH_WEATHER_PROMISE_UPDATE_FAILED: {
            v1: {
                add: {
                    name: 'weather_promise.update.failed.add',
                },
                remove: {
                    name: 'weather_promise.update.failed.remove',
                },
            },
            v2: {
                add: {
                    name: 'weather_promise.failed',
                    componentElementName: 'update_add',
                },
                remove: {
                    name: 'weather_promise.failed',
                    componentElementName: 'update_remove',
                },
            },
        },
        INSURTECH_WEATHER_PROMISE_PRICE_CHANGED_SUCCESS: {
            v1: {
                name: 'weather_promise.price_change.success',
            },
            v2: {
                name: 'weather_promise.succeeded',
                componentElementName: 'price_change',
            },
        },
        INSURTECH_WEATHER_PROMISE_PRICE_CHANGED_FAILED: {
            v1: {
                name: 'weather_promise.price_change.failed',
            },
            v2: {
                name: 'weather_promise.failed',
                componentElementName: 'price_change',
            },
        },
        INSURTECH_WEATHER_PROMISE_REMOVE_OFFER_FAILED: {
            v1: {
                name: 'weather_promise.remove_offer.failed',
            },
            v2: {
                name: 'weather_promise.failed',
                componentElementName: 'price_change.remove_offer',
            },
        },
        INSURTECH_WEATHER_PROMISE_PRESENTED: {
            v1: {
                name: 'weather_promise_component.presented',
            },
            v2: {
                name: 'weather_promise.presented',
            },
        },
        INSURTECH_WEATHER_PROMISE_FAILED_TO_RENDER: {
            v1: {
                name: 'weather_promise_component.render.failed',
            },
            v2: {
                name: 'weather_promise.failed',
                componentElementName: 'component.render',
            },
        },
        INSURTECH_WEATHER_PROMISE_NO_DATA: {
            v1: {
                name: 'weather_promise_component.render.failed',
            },
            v2: {
                name: 'weather_promise.hidden',
            },
        },
    },
    EDAP_VALIDATION_ERRORS: {
        SECURITY_CODE_INVALID: 'security_code_invalid',
        STREET_ADDRESS: 'street_address',
        ZIP: 'zip',
        CREDIT_CARD_NUMBER_INVALID: 'credit_card_number_invalid',
        FIRST_NAME_MISSING: 'firstName_missing',
        LAST_NAME_MISSING: 'lastName_missing',
        PHONE_FORMATTING: 'phone_formatting',
        PHONE_MISSING: 'phone_missing',
        EMAIL_FORMATTING: 'email_formatting',
        EMAIL_MISSING: 'email_missing',
        HOUSE_RULES_CHECK_MISSING: 'house_rules_check_missing',
        VAS_SELECTION: 'vas_selection',
        NATIONAL_ID_MISSING: 'national_id_missing',
        EXP_MONTH_MISSING: 'exp_month_missing',
        EXP_YEAR_MISSING: 'exp_year_missing',
        EXP_DATE_MISSING: 'exp_date_missing',
        MARKETING_OPT_IN_TYPE_FAILED: 'marketing_opt_in_type.failed',
        MARKETING_OPT_IN_USER_PREFERENCE_FAILED:
            'marketing_opt_in_user_preference.failed',
    },

    PAYMENT_FIELDS: {
        STREET1: 'street1',
        STREET2: 'street2',
        COUNTRY_CODE: 'countryCode',
        CITY: 'city',
        STATE: 'state',
        POSTAL_CODE: 'postalCode',
        NATIONAL_ID: 'nationalId',
        CREDIT_CARD_EXPIRATION: 'creditCardExpiration',
        CREDIT_CARD_EXPIRATION_YEAR: 'creditCardExpiration',
        PAN: 'pan',
        CVN: 'cvn',
        FIRST_NAME: 'firstName',
        LAST_NAME: 'lastName',
        VAT_REGISTRATION_NUMBER: 'vatRegistrationNumber',
    },

    EDAP_LABEL: {
        IPM_INVOICE: 'ipm invoice',
    },

    COMPLIANCE_TYPES: {
        EU: 'EU',
    },

    PAYMENT_METHODS: {
        CREDIT_CARD: 'CREDIT_CARD',
        ECHECK: 'ECHECK',
        OFF_PLATFORM: 'OFF_PATFORM',
        SAVED_CREDIT_CARD: 'SAVED_CREDIT_CARD',
        APPLE_PAY: 'APPLE_PAY',
        AFFIRM: 'AFFIRM',
        PAYPAL_ONLINE: 'PAYPAL_ONLINE',
    },

    FEE_TYPES: {
        DISCOUNT: 'DISCOUNT',
        FEE: 'FEE',
        LODGING_TAX: 'LODGING_TAX',
        OWNER: 'OWNER_FEE',
        PDP: 'CSA_PDP',
        PET: 'PET_FEE',
        RDD: 'RDD',
        REFUNDABLE_DAMAGE_DEPOSIT: 'REFUNDABLE_DAMAGE_DEPOSIT',
        PROPERTY_DAMAGE_PROTECTION: 'PROPERTY_DAMAGE_PROTECTION',
        RENTAL: 'RENTAL_AMOUNT',
        TRAVELER: 'TRAVELER_FEE',
        ADDITIONAL_GUESTS_AMOUNT: 'ADDITIONAL_GUESTS_AMOUNT',
        SERVICE_FEE: 'SERVICE_FEE',
    },

    CARDTYPE_FORMAT_ON_CARD: {
        AMEX: 'amex',
        BANK: 'bank',
        CARTASI: 'carta_si',
        CARTEBLANCHE: 'carte_blanche',
        CARTEBLEU: 'carte_bleu',
        DANKORT: 'dankort',
        DELTA: 'delta',
        DINERS: 'diners',
        DINERSCLUB: 'dinersclub',
        DISCOVER: 'discover',
        ECHECK: 'echeck',
        ENROUTE: 'enroute',
        JAL: 'jal',
        JCB: 'jcb',
        LASER: 'laser',
        MAESTROINTERNATIONAL: 'maestro_international',
        MAESTRO: 'maestro_uk',
        MAESTROUK: 'maestro_uk',
        MASTERCARD: 'mastercard',
        PAYPAL: 'paypal',
        SOLO: 'solo',
        VISA: 'visa',
        VISAELECTRON: 'visa_electron',
    },

    DISPLAY_CARD_TYPE: {
        maestro: 'Maestro',
        mastercard: 'Mastercard',
        dankort: 'Dankort',
        discover: 'Discover',
        jcb: 'JCB',
        forbrugsforeningen: 'Forbrugsforeningen',
        visa: 'Visa',
        amex: 'Amex',
        dinersclub: 'Diners Club',
        unionpay: 'UnionPay',
        'visa-electron': 'Visa Electron',
    },

    EXCLUDED_VAT_ID_COUNTRIES: {
        AU: 'AU',
    },

    CANCELLATION_POLICY_VALIDITY: {
        ALL_QUALIFIED: 'ALL_QUALIFIED',
        PARTIAL_QUALIFIED: 'PARTIAL_QUALIFIED',
        NON_QUALIFIED: 'NON_QUALIFIED',
    },

    INPUT_TYPE: {
        SUBMIT: 'submit',
    },

    IMAGE_CAROUSEL: {
        OVERLAY_COLOR: '#252F38',
    },

    INTERNET_RELATED_AMENITIES: {
        AMENITY_NAMES: [
            'INTERNET_ACCESS',
            'INTERNET',
            'WIRELESS_INTERNET',
            'WIFI',
        ],
    },

    EAN_TYPES: {
        HOTEL: 'HOTEL',
        EXPEDIA: 'EXPEDIA',
    },

    UPDATE_OPERATORS: {
        MODIFY_SERVICE_FEE: 'MODIFY_SERVICE_FEE',
        ADD_OFFER: 'ADD_OFFER',
        MODIFY_OFFER: 'MODIFY_OFFER',
        REMOVE_OFFER: 'REMOVE_OFFER',
    },

    TRAVEL_DETAILS: {
        CHECK_IN_DATE: 'CHECK_IN_DATE',
        CHECK_OUT_DATE: 'CHECK_OUT_DATE',
        ADULT_TRAVELERS: 'ADULT_TRAVELERS',
    },

    COUNTRY_CODES: {
        BR: 'BR',
        ES: 'ES',
        IT: 'IT',
        US: 'US',
        CA: 'CA',
        NZ: 'NZ',
        AU: 'AU',
        MX: 'MX',
    },

    LOCALES: {
        EN_US: 'en_US',
        FR_CA: 'fr_CA',
        EN_CA: 'en_CA',
    },

    EXCLUDED_URGENCY_MSG_COUNTRIES: {
        CA: 'CA',
        SG: 'SG',
        AU: 'AU',
        NZ: 'NZ',
        AT: 'AT',
        BE: 'BE',
        CH: 'CH',
        DK: 'DK',
        FI: 'FI',
        FR: 'FR',
        DE: 'DE',
        GR: 'GR',
        HU: 'HU',
        IS: 'IS',
        IE: 'IE',
        IT: 'IT',
        NL: 'NL',
        NO: 'NO',
        PT: 'PT',
        ES: 'ES',
        SE: 'SE',
        TU: 'TU',
        UK: 'UK',
        GB: 'GB',
        PL: 'PL',
    },

    BRANDS: {
        BOOKABACH: 'bookabach',
        STAYZ: 'stayz',
    },

    IPM: {
        MANAGER_NOTES_CUTOFFLENGTH: 200,
    },

    HAPI_IFRAME: {
        CVN: 'cvn',
        ACCTNUM: 'acctnum',
        PAN: 'pan',
    },

    PLATFORM_SOURCE: {
        DESKTOP: 'desktop',
        ANDROID: 'android',
        IOS: 'ios',
    },

    DAY_IN_MILLIS: 86400000,

    ITEM4: {
        IPM: 1,
        PPM: 2,
        FRBO: 3,
    },

    ENTITY_NAME: {
        VRBO: 'Vrbo',
        VRBO_IPM: 'Vrbo IPM',
    },

    IPIDMAP: {
        EA_TI_AB:
            'https://standalone-plugandsell.europ-assistance.com/media/wd/VRBO-TI-INPATH/Documents/FR/IPID_TIE_FR_fr.pdf',
        EA_TI_ES:
            'https://standalone-plugandsell.europ-assistance.com/media/wd/VRBO-TI-INPATH/Documents/ES/IPID_TIE_ES_es.pdf',
        EA_TI_FD:
            'https://standalone-plugandsell.europ-assistance.com/media/wd/VRBO-TI-INPATH/Documents/DE/IPID_TIE_DE_de.pdf',
    },
    PRICE_SHOCKER: {
        PER_DAY_THRESHOLD: 10,
        PER_PERSON_THRESHOLD: 10,
        PER_DAY_PRICE_THRESHOLD: 5,
        ABACUS_NAME: 'Insurtech_Vrbo_Vas_Pricing_Changes',
    },
    CLARITYONRDD: {
        ABACUS_NAME: 'Insurtech_VRBO_ClarityOnRDD',
    },
    INSURTECH_PRODUCTS: {
        WEATHER_PROMISE: 'WEATHER_PROMISE',
        HWC: 'CSA_HWC',
        NO_PRODUCT: 'NO_PRODUCT',
        UNKNOWN_PRODUCT: 'UNKNOWN_PRODUCT',
    },
    INSURTECH_PLACEMENT: {
        VAS_INTERSTITIAL: 'vas-interstitial',
        CKO: 'cko',
    },
    INSURTECH_GROUP_OFFER_TYPE: 'INSURTECH',
};

export default constants;
